import React, { useContext } from "react";
import Context from "../../context/conventionTrackerContext";
import "./index.scss";

/**
 * @desc Tab list for switching between products and wishlist.
 */
export const ProductTabs = () => {
  // CONSTANTS ----------------------------------------------------------------

  const { onTabClick, convention, wishlist } = useContext(Context);
  const { abbrev = "CON" } = convention;
  const { show: showWishlist } = wishlist;

  // COMPONENT ----------------------------------------------------------------

  const renderWishlistTab = () => {
    return (
      <div
        className="col-6 wishlist"
        data-is-wishlist={true}
        onClick={onTabClick}
      >
        Wishlist
      </div>
    );
  };

  return (
    <div className={`row product-tabs ${showWishlist ? "show-wishlist" : ""}`}>
      <div
        className="col-6 con-list"
        data-is-wishlist={false}
        onClick={onTabClick}
      >
        {`${abbrev} List`}
      </div>
      {renderWishlistTab()}
    </div>
  );
};
